export default "__VITE_PUBLIC_ASSET__d430792c__"